import { defineComponent as _defineComponent } from 'vue'
import { nextTick, ref, watch } from 'vue'
import { Cadastro } from 'common/types/Cadastro'
import { emailValido, obrigatorio } from '@/shareds/regras'
import SeletorDeGrauDoMacon from '@/components/SeletorDeGrauDoMacon.vue'
import { mask as vMask } from 'vue-the-mask'
import { IUser } from 'common/types/User'
import axios, { CancelTokenSource } from 'axios'
import IrmaoService from '@/services/IrmaoService'
import { alert, authModule } from '@/store'
import Irmao from 'common/types/Irmao'


export default /*#__PURE__*/_defineComponent({
  __name: 'DialogoDeCadastro',
  emits: ["confirmado"],
  setup(__props, { expose, emit }: { emit: ({
	(e: 'confirmado'): void
}), expose: any, slots: any, attrs: any }) {



const form = ref<HTMLFormElement & {
	validate: () => boolean,
	resetValidation: () => void,
}>()
const primeiroCampo = ref<HTMLInputElement>()
let cancelToken: CancelTokenSource | null = null

const mostra = ref(false)
const erroDeCim = ref<true | string>(true)
const buscando = ref(false)
const confirmando = ref(false)

const cadastro = ref<Cadastro>(criarCadastro())

function mostrar(dadosIniciais: IUser) {
	cadastro.value = dadosIniciais.role !== 'Visitante'
		? irmaoEmCadastro(dadosIniciais)
		: {
			...criarCadastro(),
			potencia: dadosIniciais.idPotencia,
		}
	mostra.value = true
	nextTick(() => {
		form.value!.resetValidation()
		nextTick(() => {
			// o campo de CIM só existe para quem ainda não é irmão
			primeiroCampo.value?.focus()
		})
	})
}

watch(() => cadastro.value.cim, async () => {
	try {
		buscando.value = true
		if (cancelToken) cancelToken.cancel()
		const novoCancelToken = axios.CancelToken.source()
		cancelToken = novoCancelToken
		erroDeCim.value = true
		await IrmaoService.get((cadastro.value.cim).toString(), {
			cancelToken: novoCancelToken.token,
		})
		buscando.value = false
		erroDeCim.value = 'CIM já existe'
	} catch (error) {
		if (axios.isCancel(error)) return
		buscando.value = false
		if (axios.isAxiosError(error) && error.response?.status === 404) return
		// o visitante não pode ver o perfil do irmão, mas o 403 indica que o CIM existe
		if (axios.isAxiosError(error) && error.response?.status === 403) {
			erroDeCim.value = 'CIM já existe'
			return
		}
		erroDeCim.value = 'Não foi possível buscar o CIM'
	}
})

async function cadastrar() {
	if (!form.value!.validate()) return
	try {
		confirmando.value = true
		await authModule.registrar(cadastro.value)
		emit('confirmado')
		mostra.value = false
	} catch (error) {
		alert.setError(error)
	} finally {
		confirmando.value = false
	}
}

expose({ mostrar })

function irmaoEmCadastro(irmao: Irmao): Cadastro {
	return {
		...irmao,
		telefone: irmao.telefones[0]?.valor || '',
		email: irmao.email ?? '',
		potencia: irmao.potencia._id,
		loja: irmao.loja.nome,
	}
}

function criarCadastro(): Cadastro {
	return {
		nomeCompleto: '',
		loja: '',
		grauMacon: 'Aprendiz',
		cim: '',
		telefone: '',
		email: '',
		potencia: '',
		cargoDeAdminDaLoja: '',
		cargoDeAdminDaPotencia: '',
		ultimaAtualizacao: '',
	}
}

return { __sfc: true,emit, form, primeiroCampo, cancelToken, mostra, erroDeCim, buscando, confirmando, cadastro, mostrar, cadastrar, irmaoEmCadastro, criarCadastro, emailValido, obrigatorio, SeletorDeGrauDoMacon, vMask }
}

})